/**
 * @description: 营业平衡表（商务版）
 * @author: lyr
*/
<template>
    <div class="balance-business-report">
        <div class="red-tip">注：1 该表仅适用于全部使用低消开房业务的门店；2 仅适用于商品全部后结业务的门店；3 不适用于低消开房情况下使用“电子优惠券”“会员积分抵扣金额”业务的统计；</div>
        <div class="balance-list">
            <el-form :inline="true" :model="balance_list_form" size="small">
                <el-form-item label="时间">
                    <div class="clearfix" ref="balance_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="balance_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="balance_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="balance_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="消费包厢">
                    <el-select v-model="balance_list_form.room_id" filterable clearable placeholder="请选择包厢" :disabled="balance_list_form.room_disabled">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预订人">
                    <el-input v-model="balance_list_form.book_admin_name" placeholder="请输入预订人姓名"></el-input>
                </el-form-item>
                <el-form-item label="账单号">
                    <el-input v-model="balance_list_form.bill_no" placeholder="请输入账单号"></el-input>
                </el-form-item>
                <el-form-item label="列表显示字段">
                    <el-input v-model="showStr" placeholder="请选择要显示的字段" readonly @click.native="openChoosePop"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="balanceQuery">查询</el-button>
                    <el-button @click="balanceExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-txt">
                <div class="item" v-for="item in count_data">{{item.name}}：{{item.value}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="balance_list_table">
                <el-table-column :prop="item.key" :label="item.name" v-for="item in showStrArr" :min-width="item.key=='bill_no'?'200px':''"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="balance_list_page"
                :total="balance_list_total"
                @current-change="getList">
            </el-pagination>

            <!-- 包厢区域选择 -->
            <div class="room-area-pop" ref="room_area_pop">
                <div class="checkbox-wrapper">
                    <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                    <el-checkbox-group v-model="balance_list_form.room_area" @change="handleCheckRoomAreaChange">
                        <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div> 
            </div>

            <!-- 选择显示字段弹窗 -->
            <div class="choose-show-str-pop" ref="choose_show_str_pop">
                <el-checkbox :indeterminate="balance_choose_sign" v-model="balance_choose_all" @change="balanceChooseAll">全选</el-checkbox>
                <el-checkbox-group v-model="balance_choose_ids" @change="balanceChooseChange">
                    <el-checkbox :label="item.key" v-for="item in balance_key_arr">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
    
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="balance_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="balance_export_sign" v-model="balance_export_all" @change="balanceExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="balance_export_ids" @change="balanceExportChange">
                    <el-checkbox :label="item.key" v-for="item in balance_key_arr">{{item.name}}</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="balance_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="balance_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'balance-business-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                balance_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_id: '',
                    bill_no: '',
                    room_area: [],
                    book_admin_name: '',
                },
                balance_list_table: [],
                balance_list_page: 1,
                balance_list_total: 0,
                count_data: [],
                balance_key_arr: [], // 列表原始字段
                showStr: '全部',
                showStrArr: [], // 列表显示的字段
                balance_choose_sign: false,
                balance_choose_all: false,
                balance_choose_ids: [],
                balance_choose_list: [],
                balance_export_sign: false,
				balance_export_all: false,
                balance_export_ids: [],
                balance_export_type: '1',
                checkAllRoomArea: false,

            }
        },
        computed: {
            room_area_str() {
                if (this.balance_list_form.room_area.length == 0) {
                    return ''
                }else if(this.balance_list_form.room_area.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.balance_list_form.room_area.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            this.balance_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.balance_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.balance_list_form.shop_id = this.shop_list[0].id;
                this.getRoom(this.shop_list[0].id);
                this.getRoomArea(this.shop_list[0].id);
                this.getList(1); // 首次获取列表
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.balance_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').hour(8).minute(0).toDate(),
                    endDate: moment().hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.balance_list_form.start_date = start.format('YYYY-MM-DD HH:mm');
                    _this.balance_list_form.end_date = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 获取门店
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 更换门店
            changeShop(val) {
                this.balance_list_form.shop_id = val
                if (!!val) {
                    this.balance_list_form.room_area = []
                    this.balance_list_form.room_id = '0'
                 
                    this.getRoomArea(val)
                    this.getRoom(val)
                }
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                _this.isFirstGetList = true

                if(shop_id == '') {
                    _this.balance_list_form.room_id = '';
                    _this.balance_list_form.room_disabled = true;
                } else {
                    _this.balance_list_form.room_id = '';
                    _this.balance_list_form.room_disabled = false;
                    Vue.axios.post('Shop/getAllRoom', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_list = res.data.response.result;
                            _this.room_list.unshift({
                                id: '',
                                name: '全部'
                            })
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },

             // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_room_area = _this.balance_list_form.room_area
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.balance_list_form.room_area = c_room_area
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.balance_list_form.room_area = c_room_area
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.balance_list_form.room_area = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.balance_list_form.room_area.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

            // 列表
            getList(page) {
				const _this = this;

                _this.loading = true;
				Vue.axios.post('FinanceReport2/getBusinessBillBalance', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.balance_list_form.start_date,
                            "end_date": _this.balance_list_form.end_date,
                            "shop_id": _this.balance_list_form.shop_id,
                            "room_area": _this.balance_list_form.room_area,
                            "room_id": _this.balance_list_form.room_id,
                            "book_admin_name": _this.balance_list_form.book_admin_name,
                            "bill_no": _this.balance_list_form.bill_no
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.balance_list_total = Number(res.data.response.result.data.total);
                            _this.count_data = res.data.response.result.data.count_data
                        }
                        if (_this.isFirstGetList) { // 首次获取列表数据需将所有可显示字段保存
                            _this.balance_key_arr = res.data.response.result.column_arr;
                            _this.showStrArr = res.data.response.result.column_arr;
                            _this.showStr = '全部'
                            _this.formateChooseList(res.data.response.result.column_arr) 
                            _this.isFirstGetList = false
                        }
						_this.balance_list_table = res.data.response.result.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			balanceQuery() {
                this.balance_list_page = 1
				this.getList(this.balance_list_page);
            },

            // 打开显示字段选择弹窗
            openChoosePop() {
                let _this = this
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择要显示的字段', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.choose_show_str_pop)
                }, function() {
                    if (_this.balance_choose_ids.length < 1) {
                        layer.msg("请选择要显示的字段")
                    }else {
                        if (_this.balance_choose_ids.length == _this.balance_key_arr.length) { // 全选
                            _this.showStrArr = _this.balance_key_arr
                        }else {
                            _this.showStrArr = []
                            _this.balance_key_arr.forEach(item => {
                                let index = _this.balance_choose_ids.findIndex(v => v == item.key)
                                if (index > -1) {
                                    _this.showStrArr.push(item)
                                }
                            })
                            _this.showStr = _this.showStrArr[0].name + '...' 
                        }
                        layer.closeAll()
                    }
                });
            },

            // 可选择的全部字段
            formateChooseList(arr) {
                let res = []
                if (arr.length > 0) {
                    arr.forEach(item => {
                        res.push(item.key)
                    })
                }
                this.balance_choose_list = res
            },

            //全选
            balanceChooseAll(val) {
                this.balance_choose_ids = val ? this.balance_choose_list : []
                this.balance_choose_sign = false
            },

            balanceChooseChange(val) {
                const len = val.length;
                this.balance_choose_all = len === this.balance_choose_list.length;
                this.balance_choose_sign = len > 0 && len < this.balance_choose_list.length;
            },

            // 导出
            balanceExportAll(val) {
				this.balance_export_ids = val ? this.balance_choose_list : [];
				this.balance_export_sign = false;
			},
			balanceExportChange(val) {
				const len = val.length;
				this.balance_export_all = len === this.balance_choose_list.length;
				this.balance_export_sign = len > 0 && len < this.balance_choose_list.length;
			},
            balanceExportSet() {
                const _this = this
                this.balance_export_ids = this.balance_choose_ids

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.balance_list_export)
                }, function() {
                    _this.balanceExport();
                });
            },
            balanceExport() {
                window.location.href = Vue.ctUrl + "FinanceReport2/billBusinessBalanceExport?" +
                    "&start_date=" + this.balance_list_form.start_date +
                    "&end_date=" + this.balance_list_form.end_date +
                    "&shop_id=" + this.balance_list_form.shop_id +
                    "&room_area=" + this.balance_list_form.room_area +
                    "&room_id=" + this.balance_list_form.room_id +
                    "&book_admin_name=" + this.balance_list_form.book_admin_name +
                    "&bill_no=" + this.balance_list_form.bill_no +
                    "&export_fields=" + JSON.stringify(this.balance_export_ids) +
                    "&export_type=" + this.balance_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        margin-bottom: 10px;
        color: red;
    }
    .total-txt {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 40px;
        }
    }
    .room-area-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
    .choose-show-str-pop,
    .export-wrap {
        display: none;
        .el-checkbox {
            width: 160px;
            margin: 10px 20px 0 0;
        }
    }
</style>